// External
import React, { Component } from "react";
import { connect } from "react-redux";
// import { store } from '../../store';
import { clearReportCanvasserEvents } from "../../store/actions";
import FromToDatePickerInput from "../theme/forms/FromToDatePickerInput";
import "rc-time-picker/assets/index.css";
import Moment from "moment";

// Internal
import FloatHeader from "../theme/headers/FloatHeader";
import BasicButton from "../theme/buttons/BasicButton";
import ColorCheckbox from "../theme/forms/ColorCheckbox";
import {
  pullCampaignOffices,
  pullCanvasserEvents,
} from "../../store/api/calls";
import { defaultMapState, styles } from "./CreateSite";
import "../../styles/printMap.scss";

import BaseMap, { setBoundsToSources } from "../maps/BaseMap";
import { starStyle } from "../maps/olStyles";
import { defaultSymbolStyle, mapReportsStyle } from "../maps/BaseMapStyles";

export const legendStyles = {
  check_in: {
    color: "#1f78b4",
    staticColor: "0x1f78b4",
  },
  check_out: {
    color: "#e31a1c",
    staticColor: "0xe31a1c",
  },
  log_response: {
    color: "#6a3d9a",
    staticColor: "0x6a3d9a",
  },
  create_site: {
    color: "#ffbe00",
    staticColor: "0xffbe00",
  },
  location_update: {
    color: "#cab2d6",
    staticColor: "0xcab2d6",
  },
  door_canvass: {
    color: "#fbb034",
    staticColor: "0xfbb034",
  },
  site_contact_attempt: {
    color: "#33a02c",
    staticColor: "0x33a02c",
  },
  inactive: {
    color: "black",
  },
};

//map status to class names in css
const legendClassMapping = {
  check_in: "_blue",
  check_out: "_red",
  log_response: "_purple",
  create_site: "_orange",
  location_update: "_lilac",
  door_canvass: "_orange",
  site_contact_attempt: "_green",
  inactive: "_grey",
};

const printIframe = (id) => {
  const iframe = document.frames
    ? document.frames[id]
    : document.getElementById(id);
  const iframeWindow = iframe.contentWindow || iframe;

  iframe.focus();
  iframeWindow.print();

  return false;
};

class MapReports extends Component {
  constructor(props) {
    super(props);

    this.state = {
      ...defaultMapState,
      showCanvasserSelect: false,
      sideBarClosed: false,
      disablePrint: true,
      buildPrintMap: false,
      iframeLoading: false,
      selectedOffice: -1,
      selectedCanvasser: -1,
      startDate: "",
      endDate: "",
      officeEvents: [],
      features: [],
      offices: [],
      from: new Date(),
      to: new Date(),
      canvasser_events: {
        check_in: true,
        check_out: true,
        log_response: true,
        site_contact_attempt: false,
        door_canvass: true,
        location_update: false,
        create_site: false,
      },
    };
  }

  componentDidMount() {
    // listen for the print window load finish event
    // this.props.clearReportCanvasserEvents();
    this.handleMountOrCampaignUpdate();
  }

  handleMountOrCampaignUpdate = () => {
    pullCampaignOffices().then(() => {
      this.setState(
        {
          offices: this.encodeOfficeIcons(
            this.props.campaignOffices,
            "office-symbols"
          ),
        },
        () => setBoundsToSources([{ data: this.state.offices }], this.mapRef)
      );
    });
  };

  // don't save request data when navigating away from the page.
  componentWillUnmount() {
    this.props.clearReportCanvasserEvents();
  }

  // Check to see if checkboxes have been selected and return appropriate color for them
  getActiveStyle(event) {
    if (this.state.canvasser_events[event]) {
      return legendStyles[event];
    } else {
      return legendStyles["inactive"];
    }
  }

  renderOfficeMarkers() {
    let offices;
    let visible = true;
    let focused = false;

    // render all
    if (this.state.selectedOffice == -1) {
      offices = this.props.campaignOffices.map((d, i) => {
        d.style = starStyle();
        return d;
      });
    } else {
      // filter through campaign offices and only render selectedOffice
      offices = this.props.campaignOffices.filter((office) => {
        if (office.id == this.state.selectedOffice) {
          office.style = starStyle();
          return office;
        }
      });
    }
    return offices;
  }

  filterEventMarkers() {
    if (this.props.data) {
      let _markerPoints = this.props.data
        .filter((d) => !(!d || d.latitude === 0 || d.longitude === 0))
        .filter((d) => {
          return this.state.selectedOffice > 0
            ? d.canvasser.office == this.state.selectedOffice
            : true;
        })
        .filter((d) => {
          return this.state.selectedCanvasser > 0
            ? d.canvasser.id == this.state.selectedCanvasser
            : true;
        });
      return _markerPoints;
    }
  }

  uuidv4() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
      /[xy]/g,
      function (c) {
        var r = (Math.random() * 16) | 0,
          v = c == "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      }
    );
  }

  handleOfficeSelectChange(e) {
    // when selecting a single office reset the map bounds to fit it.
    let lat_lng = [];
    if (e.target.value != -1) {
      let office = this.props.campaignOffices.filter(
        (item) => item.id == e.target.value
      );
    } else {
      // If selecting all offices zoom out to see that area
      // lat_lng = this.combineMapData(this.props.campaignOffices);
      this.renderOfficeMarkers();
    }

    this.setState({
      selectedOffice: e.target.value,
      renderCanvasserOptions: false,
    });
  }

  handleCanvasserSelectChange(e) {
    this.setState({
      selectedCanvasser: e.target.value,
    });
  }

  handleDateChange = (from, to) => {
    this.setState({
      from,
      to,
    });
  };

  // @param event_key - string - indicates which cavasser_event should be toggled.
  handleCheckboxChange(event_key) {
    let canvasser_events = { ...this.state.canvasser_events };
    canvasser_events[event_key] = !canvasser_events[event_key];
    this.setState({ canvasser_events });
  }

  // build color coded event checkboxes in sidebar
  renderEventLegend() {
    let legend = [];
    let canvasser_events = { ...this.state.canvasser_events };

    for (let key in canvasser_events) {
      let active = canvasser_events[key];

      legend.push(
        <ColorCheckbox
          color={
            active ? legendStyles[key].color : legendStyles.inactive.color
          }
          handleChange={this.handleCheckboxChange.bind(this, key)}
          value={active}
          title={this.formatKey(key)}
          key={key}
        />
      );
    }

    return legend;
  }

  _renderSideBarClusterTopDisplay() {
    const allData = this.props.data;
    let data;

    if (this.state.selectedCanvasser > 0) {
      data = allData.filter(
        (d) => d.canvasser.id == this.state.selectedCanvasser
      );
    } else {
      data = allData;
    }

    return (
      <div className=" side-bar-scroll">
        <div className="side-menu-title">
          <h2 style={styles.title}>Map Reports</h2>
          <div className="fieldWrapper">
            <h5>Offices</h5>
            <select
              id="office-report-select"
              value={this.state.selectedOffice}
              onChange={this.handleOfficeSelectChange.bind(this)}
            >
              {this.renderOptions(this.props.campaignOffices, "All Offices")}
            </select>
          </div>
          {this.state.showCanvasserSelect ? (
            <div className="fieldWrapper">
              <h5>Filter By Canvasser</h5>
              <select
                id="canvasser-report-select"
                value={this.state.selectedCanvasser}
                onChange={this.handleCanvasserSelectChange.bind(this)}
              >
                {this.renderCanvasserOptions(this.props.data, "All Canvassers")}
              </select>
            </div>
          ) : null}
          <h5>Date Range</h5>
          <div className="button-table-top-wrapper">
            <FromToDatePickerInput
              handleDateChange={this.handleDateChange}
              from={this.state.from}
              to={this.state.to}
            />
          </div>
          <h5>Canvasser Events</h5>
          {this.renderEventLegend()}
        </div>
        <div className="side-menu-data-box">
          {(this.props.data.length && (
            <div>
              Reporting <span className="primary-text">{data.length}</span>{" "}
              total events.
            </div>
          )) ||
            null}
          {(this.props.data.length && this.state.canvasser_events.check_in && (
            <div>
              <span style={{ color: legendStyles.check_in.color }}>
                {data.filter((d) => d.event_type === "check_in").length}
              </span>{" "}
              check ins
            </div>
          )) ||
            null}
          {(this.props.data.length && this.state.canvasser_events.check_out && (
            <div>
              <span style={{ color: legendStyles.check_out.color }}>
                {data.filter((d) => d.event_type === "check_out").length}
              </span>{" "}
              check outs
            </div>
          )) ||
            null}
          {(this.props.data.length &&
            this.state.canvasser_events.log_response && (
              <div>
                <span style={{ color: legendStyles.log_response.color }}>
                  {data.filter((d) => d.event_type === "log_response").length}
                </span>{" "}
                responses
              </div>
            )) ||
            null}
          {(this.props.data.length &&
            this.state.canvasser_events.create_site && (
              <div>
                <span style={{ color: legendStyles.create_site.color }}>
                  {data.filter((d) => d.event_type === "create_site").length}
                </span>{" "}
                created sites
              </div>
            )) ||
            null}
          {(this.props.data.length &&
            this.state.canvasser_events.door_canvass && (
              <div>
                <span style={{ color: legendStyles.door_canvass.color }}>
                  {data.filter((d) => d.event_type === "door_canvass").length}
                </span>{" "}
                doors canvassed
              </div>
            )) ||
            null}
          {(this.props.data.length &&
            this.state.canvasser_events.location_update && (
              <div>
                <span style={{ color: legendStyles.location_update.color }}>
                  {
                    data.filter((d) => d.event_type === "location_update")
                      .length
                  }
                </span>{" "}
                location updates
              </div>
            )) ||
            null}
        </div>
      </div>
    );
  }

  // side effect only. add params for events that are checked.
  includeEventOrNot(paramObj) {
    let events = { ...this.state.canvasser_events };

    for (let key in events) {
      if (events[key]) {
        paramObj[key] = 1;
      }
    }
  }

  // Create the query params object used in api request
  buildReportParams() {
    let params = {
      campaign: +this.props.focusedCampaign.id,
      start: new Moment(this.state.from).format("YYYY-MM-DD"),
      end: new Moment(this.state.to).format("YYYY-MM-DD"),
    };

    // add selected events to params
    this.includeEventOrNot(params);

    // If an office has been chosen add it to the query params
    if (this.state.selectedOffice != -1) {
      params.office = +this.state.selectedOffice;
    }

    if (this.state.selectedCanvasser != -1) {
      params.canvasser = +this.state.selectedCanvasser;
    }

    return params;
  }

  runReport() {
    // clear out any previously rendered markers
    this.props.clearReportCanvasserEvents();

    // request for new data then set the map bounds
    pullCanvasserEvents(this.buildReportParams()).then((res) => {
      this.setState(
        {
          showCanvasserSelect: true,
          disablePrint: false,
          features: this.encodePoints(
            [...this.filterEventMarkers()], // , ...this.renderOfficeMarkers()
            "event-points"
          ),
        },
        () => {
          setBoundsToSources([{ data: this.state.features }], this.mapRef);
        }
      );
    });
  }

  // make human readable key for dynamically generated labels
  formatKey(key) {
    return key.replace("_", " ");
  }

  buildPrintMap() {
    // only build iframe when we want the static map built
    if (this.state.buildPrintMap) {
      return (
        <iframe
          id="ifmcontentstoprint"
          src={"/print-map-report"}
          style={{ display: "none" }}
          title="Map Report"
        />
      );
    }
  }

  buildPrintLegend() {
    let boxes = [];

    for (let key in legendStyles) {
      let color = legendStyles[key].color;
      if (key !== "inactive" && this.state.canvasser_events[key]) {
        boxes.push(
          <span key={key}>
            <div
              className="legendColor column"
              style={{ backgroundColor: color }}
            ></div>
            <div className="legendText column">{this.formatKey(key)}</div>
          </span>
        );
      }
    }

    // then all events are being shown b/c none are selected, so build the legend accordingly.
    if (!boxes.length) {
      for (let key in legendStyles) {
        let color = legendStyles[key].color;
        if (key !== "inactive") {
          boxes.push(
            <span key={key}>
              <div
                className="legendColor column"
                style={{ backgroundColor: color }}
              ></div>
              <div className="legendText column">{this.formatKey(key)}</div>
            </span>
          );
        }
      }
    }

    const datestring =
      new Moment(this.state.from).format("YYYY-MM-DD") +
      " to " +
      new Moment(this.state.to).format("YYYY-MM-DD");

    boxes.push(
      <span>
        <div className="legendText column" style={{ marginLeft: "30px" }}>
          {datestring}
        </div>
      </span>
    );

    return (
      <div id="printLegend">
        <div>{boxes}</div>
      </div>
    );
  }

  handlePrint(print_id) {
    window.print();
  }

  // build a giant query string to use for the src tag for the print iframe so it understands what data to load.
  buildMapParams() {
    let result = `?center=${this.state.center.lat},${this.state.center.lng}&size=600x400&scale=4&zoom=${this.state.zoom}`;

    // clone props
    let data = this.props.data.slice();
    // need to sort data so the markers get grouped together.
    data.sort((a, b) => {
      if (a.event_type < b.event_type) {
        return -1;
      } else if (a.event_type > b.event_type) {
        return 1;
      } else {
        return 0;
      }
    });

    let styleKey;

    data.forEach((item, index) => {
      if (styleKey !== item.event_type) {
        styleKey = item.event_type;
        result += `&markers=color:` + legendStyles[styleKey]["staticColor"];
        result += "%7csize:tiny";
      }

      // filter out 0,0 data here too
      if (item.latitude !== 0 || item.longitude !== 0) {
        result += "%7C" + item.latitude + "," + item.longitude;
      }
    });

    // add star marker for offices to the lineup of markers
    result +=
      "&markers=icon:https://findicons.com/files/icons/1620/crystal_project/22/knewstuff.png";

    if (this.state.selectedOffice === -1) {
      this.props.campaignOffices.forEach((item, index) => {
        result += "%7C" + item.lat + "," + item.lon;
      });
    } else {
      let selected = this.props.campaignOffices.find(
        (elem) => elem.id == this.state.selectedOffice
      );

      result += "%7C" + selected.lat + "," + selected.lon;
    }

    return result;
  }

  renderOptions(props, label) {
    let options = props.map((d) => {
      return (
        <option key={d.name + "_" + d.id} value={d.id}>
          {d.name}
        </option>
      );
    });

    // set up the default option to display all options
    options.push(
      <option key={"default_option"} value={-1}>
        {label}
      </option>
    );

    return options;
  }

  renderCanvasserOptions(props, label) {
    let canvasser_ids = props
      .filter(
        (data) =>
          this.state.selectedOffice == -1 ||
          data.canvasser.office == this.state.selectedOffice
      )
      .map((d) => d.canvasser.id);
    canvasser_ids = [...new Set(canvasser_ids)];

    let filtered = [];
    props.forEach((d) => {
      let idx = canvasser_ids.findIndex((i) => i === d.canvasser.id);
      if (idx > -1) {
        filtered.push(d);
        canvasser_ids.splice(idx, 1);
      }
    });

    let sorted = filtered.sort((a, b) =>
      a.canvasser.lastname.localeCompare(b.canvasser.lastname)
    );

    let options = sorted.map((d) => {
      return (
        <option key={d.name + "_" + d.id} value={d.canvasser.id}>
          {d.canvasser.firstname + " " + d.canvasser.lastname}
        </option>
      );
    });

    // set up the default option to display all options
    options.unshift(
      <option key={"default_option"} value={-1}>
        {label}
      </option>
    );

    return options;
  }

  encodePoints = (points, source) => {
    return {
      type: "FeatureCollection",
      features: points.map((point) => {
        return {
          type: "Feature",
          id: point.id,
          source: source,
          geometry: {
            type: "Point",
            coordinates: [+point.longitude || 0, +point.latitude || 0],
          },
          properties: {
            data: point,
            groupColor: legendStyles[point.event_type]?.color || "black",
          },
        };
      }),
    };
  };

  encodeOfficeIcons = (offices, source) => {
    return {
      type: "FeatureCollection",
      features: offices.map((office) => {
        return {
          type: "Feature",
          id: office.id,
          source: source,
          geometry: {
            type: "Point",
            coordinates: [+office.lon || 0, +office.lat || 0],
          },
          properties: {
            data: office,
            iconName: "star",
            iconColor: "#e0c516",
            iconSize: 0.85,
          },
        };
      }),
    };
  };

  render() {
    let loading = this.props.loading || this.state.loading;

    return (
      <div className="map-report-print-wrapper">
        <FloatHeader link="/dash" />
        <div style={{ width: "100vw", height: "100vh" }}>
          <BaseMap
            disableDraw
            requiredIcons={[{ iconName: "star", iconSrc: "/icons/star.png" }]}
            handleViewChange={(viewState, ref) => {
              if (ref) this.mapRef = ref;
            }}
            sources={[
              {
                id: "event-points",
                type: "geojson",
                data: this.state.features,
                style: mapReportsStyle,
                isInteractive: false,
                onHover: (feature) => {},
                onEndHover: (feature) => {},
                onDblClick: (feature) => {},
              },
              {
                id: "office-symbols",
                type: "geojson",
                data: this.state.offices,
                style: defaultSymbolStyle,
                isInteractive: false,
                onHover: (feature) => {},
                onEndHover: (feature) => {},
                onDblClick: (feature) => {},
              },
            ]}
          />
        </div>
        {/*<OLMap*/}
        {/*  features={this.state.features}*/}
        {/*  uuid={this.state.uuid}*/}
        {/*  highlightPoints={this.state.focusedSites}*/}
        {/*  toolTipDisplayMech="click"*/}
        {/*  defaultPointStyle={this.defaultStyle}*/}
        {/*  onDblClick={this.handleDblClick}*/}
        {/*  hoverCallBack={(point) => this.onMarkerHover(point)}*/}
        {/*  zoomInCallBack={(val) => this.setState({ zoom: val })}*/}
        {/*  zoomOutCallBack={(val) => this.setState({ zoom: val })}*/}
        {/*  panCallBack={(c) => this.setState({ center: { lat: c[1], lng: c[0] } })}*/}
        {/*  boundsCallBack={(bounds) => this.handleBoundsChange(bounds)}*/}
        {/*  mapTypeCallBack={(type) => this.setState({ mapType: type })}*/}
        {/*  focusedPoints={this.state.focusedSites}*/}
        {/*  ref={this.olMap}*/}
        {/*/>*/}
        <div
          className={`no-print map-side-menu ${
            this.state.sideBarClosed && "closed"
          }`}
        >
          <div className="side-menu-wrapper" id="side-menu-scroll-wrapper">
            {this._renderSideBarClusterTopDisplay()}
            <div
              className="mapButtonsPadding"
              style={{ backgroundColor: "white" }}
            >
              <BasicButton
                label="Run Report"
                on_click={this.runReport.bind(this)}
                aria_label="run report"
                on_change={() => undefined}
                className="primary mapButton"
              />
              <BasicButton
                label="Print"
                className="primary mapButton"
                on_click={this.handlePrint.bind(this, "ifmcontentstoprint")}
                aria_label="print"
                on_change={() => undefined}
                disabled={this.state.disablePrint}
              />
            </div>
          </div>
          <div
            className={`side-menu-select-wrapper ${
              this.state.sideBarClosed && "closed"
            }`}
          >
            <div
              className="side-menu-option toggle"
              style={{ marginTop: "12vh" }}
              onClick={() =>
                this.setState({ sideBarClosed: !this.state.sideBarClosed })
              }
            >
              <i
                className={`fas ${
                  this.state.sideBarClosed ? "fa-arrow-left" : "fa-arrow-right"
                }`}
              />
            </div>
            {loading && (
              <div className={`side-menu-option loading`}>
                <i className="fas fa-asterisk" />
              </div>
            )}
          </div>
        </div>
        {this.buildPrintMap()}
        {this.buildPrintLegend()}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  focusedCampaign: state.session.focusedCampaign,
  campaignOffices: state.offices.data,
  loading: state.reportCanvasserEvents.loading,
  error: state.reportCanvasserEvents.error,
  data: state.reportCanvasserEvents.data,
});

// TODO: is this necessary on this page?
const mapDispatchToProps = (dispatch) => ({
  clearReportCanvasserEvents: () => dispatch(clearReportCanvasserEvents()),
});

export default connect(mapStateToProps, mapDispatchToProps)(MapReports);
